module.exports = __webpack_public_path__ + "resources/img/main_banner_gov02_m.6e8aaf73a2969f58502b566e16476abc.png";